import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import ProductLabelTemplateWithConfiguration from '@square/dashboard-items-data/models/squareup/inventory/v3/product-label-template-with-configuration';
export default ProtoBaseModel.extend({
  templatesWithConfigurations: repeated(ProductLabelTemplateWithConfiguration),
  mostRecentTemplateToken: attr(String)
});